import React, { createContext, useState, useEffect } from "react";
import ContractorBillingService from "../../services/ContractorBillingService";
import { useTranslation } from "react-i18next";
import * as Constants from '../../utils/Constants';
import appSettings from "../../utils/AppSetting";
import {
    MessageAlert,
    SpinLoading,
} from "../../components/Components";
import { MemorizedCorrectiveDetail } from "./SpecialBilling";
const formDataContext = createContext();
function SpecialBillingPage() {
    const UserInfoData = JSON.parse(localStorage.getItem("userData"));
    const [selectedSubNo, setSelectedSubNo] = useState(JSON.parse(localStorage.getItem("subNoData"))?.value);
    const { t } = useTranslation();
    const _contractorBillingService = ContractorBillingService();
    const [isLoading, setIsLoading] = useState(false);
    const [organizeList, setOrganizeList] = useState(null);
    const [workerList, setWorkerList] = useState([]);
    const [statusList, setStatusList] = useState(null);
    const [tradeDiscountPercent, setTradeDiscountPercent] = useState(null);
    const [tradeDiscountDate, setTradeDiscountDate] = useState(null);
    const [billTypeList, setBillTypeList] = useState(null);

    const getOrganizeList = async (status, displayDialog) => {
        try {
            setIsLoading(true);
            let listOrganize = await _contractorBillingService.GetOrganizeList({
                isStatusActivce: status
            });
            if (!listOrganize?.isSuccess) throw new Error(listOrganize?.statusMessage);
            setIsLoading(false);
            return listOrganize?.result?.organizeLists;
        } catch (error) {
            setIsLoading(false);
            if (displayDialog) {
                MessageAlert.error({
                    title: t('Error'),
                    message: t('InternalError'),
                });
            }
            return null;
        }
    };

    const getWorkerList = async (subNoData, displayDialog) => {
        try {
            setIsLoading(true);
            let listWorker = await _contractorBillingService.GetWorkerList({
                subNo: subNoData
            });
            if (!listWorker?.isSuccess) throw new Error(listWorker?.statusMessage);
            setIsLoading(false);
            return listWorker?.result?.workerLists;
        } catch (error) {
            setIsLoading(false);
            if (displayDialog) {
                MessageAlert.error({
                    title: t('Error'),
                    message: t('InternalError'),
                });
            }
            return null;
        }
    }

    const getConfig = async (paramKey, displayDialog) => {
        try {
            setIsLoading(true);
            let listWorker = await _contractorBillingService.GetConfig({
                paramType: paramKey
            });
            if (!listWorker?.isSuccess) throw new Error(listWorker?.statusMessage);
            setIsLoading(false);
            return listWorker?.result?.configList;
        } catch (error) {
            setIsLoading(false);
            if (displayDialog) {
                MessageAlert.error({
                    title: t('Error'),
                    message: t('InternalError'),
                });
            }
            return null;
        }
    }

    const getBillingDetail = async (rq) => {
        try {
            setIsLoading(true);
            let listWorker = await _contractorBillingService.GetBillingList(rq);
            if (!listWorker?.isSuccess) {
                if (listWorker.statusCode === Constants.StatusCode.DataNotFound) throw new Error(t('DataNotFound'));
                else throw new Error(listWorker?.statusMessage);
            }
            setIsLoading(false);
            return listWorker?.result;
        } catch (error) {
            setIsLoading(false);
            MessageAlert.error({
                title: t('Error'),
                message: error.message,
            });
            return null;
        }
    }

    const getQueueDetail = async (rq) => {
        try {
            setIsLoading(true);
            let queueDetail = await _contractorBillingService.GetQueueDetail(rq);
            if (!queueDetail?.isSuccess) {
                if (queueDetail.statusCode === Constants.StatusCode.DataNotFound) throw new Error(t('DataNotFound'));
                else throw new Error(queueDetail?.statusMessage);
            }
            setIsLoading(false);
            return queueDetail?.result;
        } catch (error) {
            setIsLoading(false);
            MessageAlert.error({
                title: t('Error'),
                message: error.message,
            });
            return null;
        }
    }

    const getSpecialBilling = async (rq) => {
        try {
            setIsLoading(true);
            let specialBillingList = await _contractorBillingService.GetSpecialBilling(rq);
            if (!specialBillingList?.isSuccess) {
                if (specialBillingList.statusCode === Constants.StatusCode.DataNotFound) throw new Error(t('DataNotFound'));
                else throw new Error(specialBillingList?.statusMessage);
            }
            setIsLoading(false);
            return specialBillingList?.result;
        } catch (error) {
            setIsLoading(false);
            MessageAlert.error({
                title: t('Error'),
                message: error.message,
            });
            return null;
        }
    }

    const getBilling = async (rq) => {
        try {
            setIsLoading(true);
            const billing = await _contractorBillingService.GetBilling(rq);
            if (!billing?.isSuccess) {
                if (billing.statusCode === Constants.StatusCode.DataNotFound) throw new Error(t('DataNotFound'));
                else throw new Error(billing?.statusMessage);
            }
            setIsLoading(false);
            return billing?.result;
        } catch (error) {
            setIsLoading(false);
            MessageAlert.error({
                title: t('Error'),
                message: error.message,
            });
            return null;
        }
    };

    const addSpecialBill = async (rq) => {
        try {
            setIsLoading(true);
            const addBilling = await _contractorBillingService.AddSpecialBill(rq);
            if (!addBilling?.isSuccess) throw new Error(addBilling?.statusMessage);
            setIsLoading(false);
            return addBilling?.result;
        } catch (error) {
            setIsLoading(false);
            MessageAlert.error({
                title: t('Error'),
                message: t('FailedtoSaveBilling'),
            });
            return null;
        }
    };

    const cancelSpecialBill = async (rq) => {
        try {
            setIsLoading(true);
            const cancelBilling = await _contractorBillingService.CancelSpecialBill(rq);
            if (!cancelBilling?.isSuccess) throw new Error(cancelBilling?.statusMessage);
            setIsLoading(false);
            return true;
        } catch (error) {
            setIsLoading(false);
            MessageAlert.error({
                title: t('Error'),
                message: t('FailedtoSaveBilling'),
            });
            return false;
        }
    };

    const receiveMessage = (event) => {
        if (event.origin === window.origin) {
            if (event.data?.subNo) {
                setSelectedSubNo(event.data?.subNo.value);
            }
        }
    };

    useEffect(() => {
        window.addEventListener('message', receiveMessage);
        fetchData();
    }, []);

    useEffect(() => {
        fetchData();
    }, [selectedSubNo]);

    const fetchData = async () => {
        try {
            setOrganizeList(await getOrganizeList(Constants.Status.Active));
            let workers = await getWorkerList(selectedSubNo);
            setWorkerList(workers);
            setStatusList(await getConfig(appSettings.configKey.jobStatus));
            let discountPercent = await getConfig(appSettings.configKey.discountPercent);
            setTradeDiscountPercent(discountPercent && discountPercent?.length > 0 ? discountPercent[0]?.configValue : null);
            let discountDate = await getConfig(appSettings.configKey.discountDate);
            setTradeDiscountDate(discountDate && discountDate?.length > 0 ? discountDate[0]?.configValue : null);
            setBillTypeList(await getConfig(appSettings.configKey.SpecialBillType));
        } catch (error) {
            MessageAlert.error({
                title: t('Error'),
                message: error?.message,
            });
        }
    }

    return (
        <>
            <formDataContext.Provider
                value={{
                    UserInfoData,
                    selectedSubNo,
                    tradeDiscountDate,
                    tradeDiscountPercent,
                    getOrganizeList,
                    getBillingDetail,
                    getQueueDetail,
                    getSpecialBilling,
                    getBilling,
                    addSpecialBill,
                    cancelSpecialBill,
                    organizeList,
                    workerList,
                    statusList,
                    billTypeList,
                }}
            >
                {isLoading && <SpinLoading />}
                <MemorizedCorrectiveDetail />
            </formDataContext.Provider>
        </>
    )
}
export { formDataContext };
export default SpecialBillingPage